import Axios from 'axios';
import {baseUrl, requestHeader} from '../../config';
import {CatchReturnError} from "./actionHandler";

export const getConsultantBadges = (UID: string) => {
    return Axios.get(baseUrl + '/getConsultantBadges/' + UID, requestHeader).then(res => {
        let response = res['data']
        return response
    }).catch(err => {
        CatchReturnError(err)
    })
}
